"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdditionalFunctions = void 0;
const axios_1 = require("axios");
const endpoints_1 = require("../forms/utils/endpoints");
const preloader_1 = require("../lib/layout/preloader");
const thankYouMessages_1 = require("../forms/utils/thankYouMessages");
const language_1 = require("../utils/language");
const endpoints = new endpoints_1.default;
class AdditionalFunctions {
    constructor(rootUrl) {
        this.mapInputNames = (form) => {
            let formData = new FormData(form);
            let formObject = {};
            formData.append('data-content', form.getAttribute('data-content'));
            formData.forEach((value, key) => formObject[key.replace('sm_', '')] = value);
            return formObject;
        };
        this.getRegisterEnv = (callback, form) => {
            let input, partnerId = this.getCookie('sm_partner');
            axios_1.default.get(`${this.url}${this.registerEnv}`)
                .then((response) => {
                if (partnerId !== null) {
                    input = document.createElement('input');
                    input.setAttribute('type', 'hidden');
                    input.setAttribute('name', 'partnerId');
                    input.setAttribute('value', partnerId);
                    form.append(input);
                    callback(this.url);
                }
                else {
                    callback(response.data);
                }
            })
                .catch(function (error) {
                console.log(error);
            });
        };
        this.getCookie = (name) => {
            let elem = document.cookie.match(new RegExp(name + '=([^;]+)'));
            return elem ? elem[1] : null;
        };
        this.renderMessageInfo = (form) => {
            form.innerHTML = '';
            (0, preloader_1.enablePreloader)(true, form);
            const messageType = form.getAttribute("data-message");
            const asset = form.getAttribute("data-url");
            const message = this.getMessageContent(messageType);
            const thankYouMessage = (this.createNewElement('div', '', 'thank-you', '', 'thank-you-message'));
            const heading = document.querySelector('#form header article');
            if (['webinar', 'webinar_it', 'webinar_es'].includes(messageType)) {
                thankYouMessage.appendChild(this.createNewElement('h2', 'form__header', '', message.header));
                thankYouMessage.appendChild(this.createNewElement('p', 'form__message', '', message.text));
            }
            else if (messageType === 'webinar-archived') {
                const videoContainer = this.createNewElement('div', 'video-container');
                if (asset) {
                    const iframe = this.createNewElement('iframe', 'iframe', asset);
                    videoContainer.appendChild(iframe);
                }
                thankYouMessage.appendChild(videoContainer);
            }
            else if (messageType === 'heroForm') {
                thankYouMessage.appendChild(this.createNewElement('h2', 'form__header', '', message.header));
                thankYouMessage.appendChild(this.createNewElement('p', 'form__message', '', message.text));
            }
            else {
                heading.innerHTML = '';
                heading.appendChild(this.createNewElement('h2', '', '', message.header));
                thankYouMessage.appendChild(this.createNewElement('p', 'form__message', '', message.text));
                message.textBold ? thankYouMessage.appendChild(this.createNewElement('p', 'form__message form__message--bold', '', message.textBold)) : '';
                asset ? thankYouMessage.appendChild(this.createNewElement('a', message.button.class, asset, message.button.text)) : '';
                message.buttonSec ? thankYouMessage.appendChild(this.createNewElement('a', message.buttonSec.class, '', message.buttonSec.text)) : '';
            }
            const timeOut = setTimeout(() => {
                (0, preloader_1.enablePreloader)(false, form);
                form.appendChild(thankYouMessage);
                this.addThankYouParam();
                clearTimeout(timeOut);
            }, 2000);
        };
        this.getMessageContent = (messageType) => {
            let message;
            const lang = (0, language_1.getLang)();
            return message = thankYouMessages_1.thankYouMessages[lang][messageType] || thankYouMessages_1.thankYouMessages[lang].default;
        };
        this.createNewElement = (tag, className, url, message, id) => {
            const element = document.createElement(tag);
            className && (element.className = className);
            if (tag === 'iframe' && url) {
                element.src = url;
                element.setAttribute("title", "YouTube video player");
                element.setAttribute("allow", "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share");
                element.setAttribute("referrerpolicy", "strict-origin-when-cross-origin");
                element.setAttribute("allowfullscreen", "");
            }
            else if (url) {
                element.href = url;
            }
            ;
            message && (element.innerHTML = message);
            id && (element.id = id);
            return element;
        };
        this.addThankYouParam = () => {
            const formUrl = window.location.href;
            const thanksParam = 'thankyou=true';
            let separator = (window.location.search === "") ? "?" : "&";
            let newUrl = formUrl + separator + thanksParam;
            window.history.pushState({
                path: newUrl
            }, '', newUrl);
        };
        this.disableBtn = (form, action) => {
            const btnForm = form.querySelector('#formBtn');
            btnForm.disabled = action;
        };
        this.phoneNumber = (form) => {
            const diallingCode = form.querySelector('[name="diallingCode"]').value;
            const number = form.querySelector('[name="phoneNumber"]').value.replace(/\s+/g, '');
            const phoneNumber = diallingCode + number;
            form.querySelector('[name="sm_phone"]').value = phoneNumber;
            return form;
        };
        this.registerEnv = endpoints.registerEnv;
        this.url = rootUrl;
    }
}
exports.AdditionalFunctions = AdditionalFunctions;
